<template>
	<div class="cart-footer">
		<h2 class="cart-footer__title">Your Info</h2>
		<template>
			<cart-footer-in-venue
				v-if="orderType === $options.orderTypes.isInVenue"
				:ref="$options.orderTypes.isInVenue"
				:is-active="orderType === $options.orderTypes.isInVenue"
				:is-loading="isLoading"
				:before-checkout="beforeCheckout"
				@set-is-loading="setIsLoading"
				@delete-order="deleteOrder"
			/>
			<cart-footer-pick-up
				v-if="orderType === $options.orderTypes.isPickUp"
				:ref="$options.orderTypes.isPickUp"
				:is-active="orderType === $options.orderTypes.isPickUp"
				:is-loading="isLoading"
				:before-checkout="beforeCheckout"
				@set-is-loading="setIsLoading"
				@delete-order="deleteOrder"
			/>
		</template>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import CartFooterInVenue from './CartFooterInVenue'
import CartFooterPickUp from './CartFooterPickUp'

import { ORDER_TYPES, PAYMENT_PROVIDER } from '@/constants'

export default {
	name: 'CartFooter',

	components: {
		CartFooterInVenue,
		CartFooterPickUp
	},

	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		beforeCheckout: {
			type: Function,
			default: () => {}
		}
	},

	orderTypes: ORDER_TYPES,
	PP_MAGENSA: PAYMENT_PROVIDER.MAGENSA,

	data() {
		return {}
	},

	computed: {
		...mapState('venue', ['venueInfo']),
		...mapState('cart', [
			'creditCardId',
			'location',
			'tableId',
			'isInVenue',
			'isPickUp',
			'hadSentAutoEmail',
			'notice',
			'pickupTimeFrom',
			'pickupTimeTo',
			'phoneNumber',
			'includeUtensils',
			'email',
			'tips',
			'tipsPercent',
			'useTipsPercent',
			'customerNameToPrint'
		]),
		...mapState('cart', {
			cartId: 'id',
			orderType: 'orderType'
		}),
		...mapGetters('venue', [
			'isTableSideOrderingAvailable',
			'isPickUpTimeAvailable',
			'isOrderingTimeAvailable',
			'caPaymentProvider'
		]),
		...mapGetters('cart', [
			'totalPrice',
			'totalProductsCount',
			'cartHasFood',
			'cartHasBeverage'
		]),

		venueSettings() {
			return this.venueInfo.settings
		},

		timeZone() {
			return this.venueInfo.timeZone
		},

		activeComponent() {
			return this.$refs[this.orderType]
		}
	},

	mounted() {
		this.isReady = true
	},

	methods: {
		...mapActions('cart', ['updateCart']),
		...mapActions('ui', ['addMainError']),

		setIsLoading(val) {
			this.$emit('set-is-loading', val)
		},

		deleteOrder() {
			this.$emit('delete-order')
		},
		creditCardAdded(creditCard) {
			if (this.activeComponent) {
				this.activeComponent.creditCardAdded(creditCard)
			}
		},
		hideCreditCardModal() {
			if (this.activeComponent) {
				this.activeComponent.hideCreditCardModal()
			}
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.cart-footer {
	&__title {
		font-size: 20px;
		margin: 0 0 15px 0;
	}

	.form__field {
		padding-top: 0;
		padding-bottom: 0;

		.form__field__input-wrapper {
			overflow: visible;
		}
	}

	.input-field,
	.form__field__input-wrapper {
		transition: border-color 0.3s linear;

		input {
			padding: 6px 24px 6px 1px;
		}
	}

	.qr {
		display: block;
		flex-shrink: 0;
		margin: 9px 0 0 24px;
		width: 34px;
		height: 34px;
		background: url('../../assets/images/ic_qr_code.svg') no-repeat 50%;
		background-size: cover;
		text-indent: -9999px;
		overflow: hidden;
		cursor: pointer;
		color: #fff;

		.disabled {
			background-color: rgba($black, 0.3);
			cursor: default;
			pointer-events: none;
		}

		&.highlighted {
			position: relative;
			background: url('../../assets/images/ic_qr_code_highlighted.svg')
				no-repeat 50%;
			background-size: cover;

			&:after {
				content: '';
				position: absolute;
				left: calc(50% - 3px);
				top: calc(50% - 3px);
				height: 6px;
				width: 6px;
				background: $alertRedLight;
				overflow: hidden;
				transform: scale(0.1);
				border-radius: 50%;
				animation: double-pulse-red 1s 3;
			}
		}

		@media (max-width: 1140px) {
			margin: 9px 0 0 24px;
		}

		@media (max-width: 767px) {
			margin: 16px -50px 0 16px;
		}
	}

	.select {
		min-width: 150px;
	}

	.time-picker {
		bottom: calc(100% + 2px);
		max-width: 100%;
		top: auto;
		padding: 16px 24px;
		z-index: 9999;
	}

	.time-picker-opener {
		font-size: 16px;
	}

	.time-picker-opener,
	.select-opener {
		transition: border-color 0.3s linear;
	}
	// Check and remove  .input-clear, .input-counter, .input-prefix from all styles in this component
	.input-clear,
	.input-counter,
	.qr,
	.input-prefix,
	.time-picker-opener:after,
	.select-opener:after,
	.form__field__clean-icon,
	.form__field__error {
		transition: opacity 0.3s linear;
	}

	&.collapsed {
		.input-field,
		.time-picker-opener,
		.input-field.phone-input.highlighted,
		.form__field__input-wrapper {
			border-color: transparent !important;
		}

		.time-picker-opener:before {
			display: none;
		}

		.time-picker-opener,
		.select-opener {
			pointer-events: none;
		}

		.input-clear,
		.qr,
		.input-counter,
		.time-picker-opener:after,
		.select-opener:after,
		.form__field__clean-icon,
		.form__field__error {
			opacity: 0;
			pointer-events: none;
		}

		.cart-footer-utensils {
			pointer-events: none;
			opacity: 0;

			&.checked {
				opacity: 1;

				.check {
					opacity: 0;
				}
			}
		}
	}

	&.ready .cart-footer-holder {
		transition: margin-bottom 0.3s linear;
	}

	.cart-footer-holder {
		opacity: 1;

		@media (max-width: 1140px) {
			padding: 0 0 12px;
		}
	}

	@media (max-width: 767px) {
		padding: 0;

		.input-field {
			margin: 0;
		}
	}
}

.cart-footer-holder {
	padding: 0 0 10px;
	opacity: 0;
	position: relative;
	z-index: 5;
}

.cart-footer-frame {
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
}

.cart-footer-block-wrap {
	width: 100%;
	display: flex;
	align-items: flex-start;
	flex-grow: 1;

	&:first-child {
		padding: 0;
	}

	@media (max-width: 767px) {
		display: block;
	}
}

.cart-footer-wrap {
	display: flex;
	align-items: flex-start;
	flex-grow: 1;

	@media (max-width: 767px) {
		width: 100%;
		padding: 0 50px 0 0;
	}
}

.cart-footer-block {
	width: 50%;
	flex-grow: 0;
	margin: 0 -15px 25px;
	.location {
		width: 100%;
		label {
			white-space: nowrap;
		}
	}
	@media (max-width: 767px) {
		width: 100%;
		margin: 0 0 25px 0;
	}
}

.cart-footer-switcher-label,
.cart-footer-label {
	display: block;
	padding: 0 0 4px;
	font-size: 12px;
	color: #9a98a2;
}

.cart-footer-switcher-label {
	padding: 0 0 10px;
}

.cart-footer-label {
	@media (max-width: 767px) {
		transition: padding-bottom 0.3s linear;
	}
}

.cart-footer-utensils {
	display: block;
	font-size: 16px;
	color: #816cc2;
	transition: all 0.3s linear;

	.check {
		overflow: hidden;
		transition: all 0.3s linear;
	}

	.checkbox-label {
		padding: 3px 0 0;
	}
}

.cart-footer-buttons-holder {
	position: fixed;
	z-index: 2;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 15px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(
			0deg,
			rgba(0, 0, 0, 0.15) 0%,
			rgba(0, 0, 0, 0.025) 100%
		);
		backdrop-filter: blur(1px);
	}
	.primary-button {
		min-width: 260px;
	}

	@media (max-width: 767px) {
		display: block;

		.primary-button {
			width: 100%;
			margin: 0 0 12px;
		}
	}
}

.cart-footer-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
	margin: 0 15px 25px;
	@media (max-width: 767px) {
		margin-left: 0;
		margin-right: 0;
	}
}
</style>
